import React from 'react';
import { makeStyles, Typography } from '~/lib/bn-material-ui';
import { useOrdersDialogStateSelector } from '../context/orders-dialog-context';
import { useSuggestionSnoozeFormData, SuggestionSnoozeForm, SuggestionSnoozeSaveButton } from '~/orders/order-suggestion-snooze-settings';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    gap: '3rem',
    flexWrap: 'wrap',
    margin: '1em 0',
  },
  binName: {
    fontWeight: 'bold',
  },
  saveContainer: {
    display: 'flex',
    gap: '1rem',
  },
}));

export function BarnSuggestionSettings() {
  const styles = useStyles();
  const [selectedBarnsBins] = useOrdersDialogStateSelector(['selectedBarnsBins']);
  const settingForms = selectedBarnsBins
    .sort((binA, binB) =>
      binA.properties.name.localeCompare(binB.properties.name, 'en', { numeric: true }),
    )
    .map(bin => {
      const binHref = bin.getLinkByRel('self').href;
      const binName = bin.properties.name;
      return (
        <BinSuggestionSettings
          binHref={binHref}
          binName={binName}
          styles={styles}
          key={binHref}
        />
      );
    });

  return (
    <div className={styles.container}>
      {settingForms}
    </div>
  );
}

function BinSuggestionSettings({ binHref, binName, styles }) {
  const formData = useSuggestionSnoozeFormData({ binHref, showUnSnoozedOption: true });

  return (
    <div className={styles.binContainer}>
      <Typography variant='body1' className={styles.binName}>{binName}</Typography>
      <SuggestionSnoozeForm {...formData} />
      <SuggestionSnoozeSaveButton {...formData} savedTextPositionRight={true} />
    </div>
  );
}
